import React, { useEffect, useRef } from 'react';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { io } from 'socket.io-client';
import 'xterm/css/xterm.css';
export default function TerminalComponent({ projectPath }) {
  const terminalRef = useRef(null);
  const term = useRef(null);
  useEffect(() => {
    term.current = new Terminal({ theme: { background: '#1e1e1e' } });
    const fitAddon = new FitAddon();
    term.current.loadAddon(fitAddon);
    term.current.open(terminalRef.current);
    fitAddon.fit();
    const socket = io();
    term.current.onData(data => socket.emit('terminal-input', data));
    socket.on('terminal-output', data => term.current.write(data));
    return () => { socket.disconnect(); term.current.dispose(); };
  }, []);
  return <div ref={terminalRef} className="h-full w-full" />;
}
